const AllocateIcon = ({ className, isSelected = false }) => {
  const fillColor = isSelected
    ? 'var(--forbrand-primary)'
    : 'var(--forbrand-secondary)'

  return (
    <div
      className={`${className} flex items-center justify-center w-[32px] h-[32px]`}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 12.5H3V8.5H4V9.5H6.5V8.5H7.75V12.5H6.75V15H9.25V12.5H8.25V8.5H9.5V9.5H12V8.5H13V12.5H12V15H14.5V12.5H13.5V8H12V7.5H11.5V9H10V7.5H10.8901L11.2402 7H9.5V8H8.25V5.5H9.29932L10.5981 3.25L9.29932 1L9.01025 1.5L10.021 3.25L9.01025 5H6.98975L5.979 3.25L6.98975 1.5H8.43286L8.72153 1H6.70068L5.40186 3.25L6.70068 5.5H7.75V8H6.5V7.25H6.25L6 7.60699V9H4.5V7.5H5.46503L5.81516 7H4V8H2.5V12.5H1.5V15H4L4 12.5ZM8.75 14.5H7.25V13H8.75V14.5ZM14 14.5H12.5V13H14V14.5ZM3.5 14.5H2V13H3.5V14.5Z"
          fill={fillColor}
          stroke={fillColor}
          stroke-width="0.4"
        />
      </svg>
    </div>
  )
}

export default AllocateIcon
